<template>
  <td
    class="position-relative"
    @mouseenter="showEditButton"
    @mouseleave="showButtons = false"
    v-if="!editMode"
  >
    <div
      class="position-absolute buttons-container"
      v-if="showButtons"
    >
      <v-button
        @click="enableEditMode"
        text="word.edit"
        icon="edit"
        style-type="secondary"
        size="xs"
        type="submit"
        :loader="{loading: loading}"
      />
    </div>
    <div v-if="answer">
      <v-item-data-raw-answer
        :answer="answer"
        :render-type="renderType"
      />
    </div>
  </td>
  <td v-else class="p-0 bg-edit">
    <form @submit.prevent="saveAnswer">
      <div class="mb-3">
        <v-text-area
          v-model="cleanedValue"
          :rows="5"
          :required="true"
        />
      </div>
      <div class="m-2 d-flex justify-content-end">
        <div class="mr-2" v-if="answer && answer.value_cleaned">
          <v-button
            icon="redo"
            text="word.reset"
            style-type="info"
            size="xs"
            @click="resetAnswer"
          />
        </div>

        <div class="mr-2">
          <v-button
            text="word.cancel"
            style-type="secondary"
            size="xs"
            @click="cancel"
          />
        </div>

        <v-button
          text="word.save"
          style-type="primary"
          size="xs"
          type="submit"
          :loader="{loading: loading}"
        />
      </div>
    </form>
  </td>
</template>

<script>
import Button from '@/common/components/Button.vue';
import ItemDataRawAnswer from '@/organisation/components/research/widgets/ItemDataRawAnswer.vue';
import TextArea from '@/common/components/inputs/TextArea.vue';
import { updateResearchAnswer } from '@/organisation/api';
import { notify } from '@/common/utils/notify';
import { mapGetters } from 'vuex';

export default {
  name: 'AnswerListCell',
  components: {
    'v-button': Button,
    'v-text-area': TextArea,
    'v-item-data-raw-answer': ItemDataRawAnswer,
  },
  data: () => ({
    editMode: false,
    showButtons: false,
    loading: false,
    cleanedValue: '',
  }),
  props: {
    answer: {
      type: Object,
      required: false,
    },
    renderType: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['user']),
  },
  methods: {
    showEditButton() {
      if (this.renderType === 'text' && !this.editMode && this.user.su) {
        this.showButtons = true;
      }
    },
    cancel() {
      this.editMode = false;
      this.initCleanedValue();
    },
    async resetAnswer() {
      this.loading = true;
      const response = await updateResearchAnswer(this.answer.id, null);
      if (response.status === 200) {
        notify(this.$t('sentence.value_reset'));
        this.editMode = false;
        this.loading = false;
        this.answer.value_cleaned = null;
        this.cleanedValue = this.answer.value_str;
      } else {
        notify(this.$t('sentence.error_occurred'), '', 'error');
        this.loading = false;
      }
    },
    async saveAnswer() {
      if (!this.cleanedValue) {
        notify(this.$t('sentence.value_required'), '', 'error');
        return;
      }

      this.loading = true;
      if (this.cleanedValue === this.answer.value_cleaned) {
        return;
      }

      const response = await updateResearchAnswer(this.answer.id, this.cleanedValue);
      if (response.status === 200) {
        notify(this.$t('sentence.value_updated'));
        this.editMode = false;
        this.loading = false;
        this.answer.value_cleaned = this.cleanedValue;
      } else {
        notify(this.$t('sentence.error_occurred'), 'error');
        this.loading = false;
      }
    },
    enableEditMode() {
      this.initCleanedValue();
      if (this.renderType === 'text' && !this.editMode) {
        this.editMode = true;
      }
    },
    initCleanedValue() {
      this.cleanedValue = this.answer.value_cleaned || this.answer.value_str;
    },
  },
};
</script>

<style scoped>

.bg-edit {
  background-color: #f8f8f8;
}

.buttons-container {
  top: 0;
  right: 0;
}
</style>
